/**
 * Parse the Supabase implicit-grant error code out of a URL hash fragment.
 *
 * When a link-crawling email scanner (or the user) follows the raw
 * `/auth/v1/verify` GET and the single-use token is already spent, Supabase
 * redirects back to the site root with an error in the hash, e.g.
 * `#error=access_denied&error_code=otp_expired&error_description=...`.
 *
 * Pure string helper so it can be unit-tested without importing
 * `supabaseClient.ts`, which has heavy module-level side effects
 * (createClient, cookie sync). `supabaseClient.ts` re-exports this bound to
 * the hash it snapshots at module load.
 *
 * @param hash The raw location hash (with or without a leading '#').
 * @returns The `error_code` value, or null when absent.
 */
export function parseAuthErrorCode(hash: string): string | null {
  const cleaned = hash.startsWith('#') ? hash.slice(1) : hash;
  return new URLSearchParams(cleaned).get('error_code');
}
